class QuantityInput extends HTMLElement {
  constructor() {
    super()
    this.input = this.querySelector('input')
    this.changeEvent = new Event('change', { bubbles: true })

    this.querySelectorAll('button').forEach((button) =>
      button.addEventListener('click', this.onButtonClick.bind(this))
    )
  }

  onButtonClick(event) {
    event.preventDefault()
    const previousValue = this.input.value

    event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown()
    if (previousValue !== this.input.value)
      this.input.dispatchEvent(this.changeEvent)
  }
}

customElements.define('quantity-input', QuantityInput)

/*
 * Shopify Common JS
 *
 */
if (typeof window.Shopify == 'undefined') {
  window.Shopify = {}
}

Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments)
  }
}

Shopify.setSelectorByValue = function (selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i]
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i
      return i
    }
  }
}

Shopify.addListener = function (target, eventName, callback) {
  target.addEventListener
    ? target.addEventListener(eventName, callback, false)
    : target.attachEvent('on' + eventName, callback)
}

Shopify.postLink = function (path, options) {
  options = options || {}
  var method = options['method'] || 'post'
  var params = options['parameters'] || {}

  var form = document.createElement('form')
  form.setAttribute('method', method)
  form.setAttribute('action', path)

  for (var key in params) {
    var hiddenField = document.createElement('input')
    hiddenField.setAttribute('type', 'hidden')
    hiddenField.setAttribute('name', key)
    hiddenField.setAttribute('value', params[key])
    form.appendChild(hiddenField)
  }
  document.body.appendChild(form)
  form.submit()
  document.body.removeChild(form)
}

Shopify.CountryProvinceSelector = function (
  country_domid,
  province_domid,
  options
) {
  this.countryEl = document.getElementById(country_domid)
  this.provinceEl = document.getElementById(province_domid)
  this.provinceContainer = document.getElementById(
    options['hideElement'] || province_domid
  )

  Shopify.addListener(
    this.countryEl,
    'change',
    Shopify.bind(this.countryHandler, this)
  )

  this.initCountry()
  this.initProvince()
}

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function () {
    var value = this.countryEl.getAttribute('data-default')
    Shopify.setSelectorByValue(this.countryEl, value)
    this.countryHandler()
  },

  initProvince: function () {
    var value = this.provinceEl.getAttribute('data-default')
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value)
    }
  },

  countryHandler: function (e) {
    var opt = this.countryEl.options[this.countryEl.selectedIndex]
    var raw = opt.getAttribute('data-provinces')
    var provinces = JSON.parse(raw)

    this.clearOptions(this.provinceEl)
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = 'none'
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement('option')
        opt.value = provinces[i][0]
        opt.innerHTML = provinces[i][1]
        this.provinceEl.appendChild(opt)
      }

      this.provinceContainer.style.display = ''
    }
  },

  clearOptions: function (selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild)
    }
  },

  setOptions: function (selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement('option')
      opt.value = values[i]
      opt.innerHTML = values[i]
      selector.appendChild(opt)
    }
  },
}

class MenuDrawer extends HTMLElement {
  get type() {
    return this.getAttribute('type')
  }

  set type(value) {
    if (value) {
      this.setAttribute('type', value)
    } else {
      this.removeAttribute('type')
    }
  }

  constructor() {
    super()

    this.mainDetailsToggle = this.querySelector(
      this.type ? 'details' : '.js-menu-drawer-main'
    )
    const summaryElements = this.querySelectorAll(
      this.type ? 'summary' : '.summary'
    )
    this.addAccessibilityAttributes(summaryElements)

    if (navigator.platform === 'iPhone')
      document.documentElement.style.setProperty(
        '--viewport-height',
        `${window.innerHeight}px`
      )

    this.addEventListener('keyup', this.onKeyUp.bind(this))
    this.addEventListener('focusout', this.onFocusOut.bind(this))
    this.bindEvents()

    let buttonClose = document.querySelectorAll('.js-drawer--close')
    buttonClose.forEach((close) =>
      close.addEventListener('click', this.onMenuClose.bind(this))
    )

    let searchModal = document.querySelector('.js-search-modal')
    searchModal.addEventListener(
      'click',
      ((event) => {

        this.showModal(event)
        this.onMenuClose(event)
      }).bind(this)
    )

    window.addEventListener('load', this.onStylecss.bind(this))
  }

  showModal(event) {
    event.preventDefault()
    document.querySelector('.header__search details').setAttribute('open', true)
    document.querySelector('.search-modal__input').focus()
    document.querySelector('.search-modal__input').setAttribute('aria-expanded', true)
    document.querySelector('.search-modal').classList.add('search-modal__full')
    trapFocus(document.querySelector('.search-modal__focusable'), document.querySelector('.search-modal'))
  }

  bindEvents() {
    this.querySelectorAll(this.type ? 'summary' : '.summary').forEach(
      (summary) =>
        summary.addEventListener('click', this.onSummaryClick.bind(this))
    )
    this.querySelectorAll('button').forEach((button) =>
      button.addEventListener('click', this.onCloseButtonClick.bind(this))
    )
  }

  addAccessibilityAttributes(summaryElements) {
    summaryElements.forEach((element) => {
      element.setAttribute('role', 'button')
      element.setAttribute('aria-expanded', false)
      element.setAttribute('aria-controls', element.nextElementSibling.id)
    })
  }

  onKeyUp(event) {
    if (event.code.toUpperCase() !== 'ESCAPE') return

    const openDetailsElement = this.type
      ? event.target.closest('[open]')
      : event.target.closest('.menu-opening')

    if (
      !openDetailsElement ||
      event.target.classList.contains('js-accordion-toggle') ||
      event.target.classList.contains('js-list-menu-item')
    )
      return

    openDetailsElement === this.mainDetailsToggle
      ? this.closeMenuDrawer(
          this.mainDetailsToggle.querySelector(
            this.type ? 'summary' : '.summary'
          )
        )
      : this.closeSubmenu(openDetailsElement)
  }

  onFocusOut(event) {
    setTimeout(() => {
      if (
        this.mainDetailsToggle &&
        this.mainDetailsToggle.classList.contains('menu-opening') &&
        !this.mainDetailsToggle.contains(document.activeElement)
      )
        this.closeMenuDrawer()
    })
  }

  onStylecss() {
    setTimeout(() => {
      this.header = document.getElementById('shopify-section-header')
      document.documentElement.style.setProperty(
        '--header-height',
        `-${this.header.offsetHeight}px`
      )
      document.documentElement.style.setProperty(
        '--hero-margin',
        `${this.header.offsetHeight}px`
      )
      this.header.classList.add('hero-fixed')
    })
  }

  onMenuClose(event) {
    event.preventDefault()
    document.querySelector('.menu-drawer__navigation-container').classList.remove('no-scroll')

    const detailsElement = this.mainDetailsToggle

    detailsElement.classList.remove('menu-opening')
    detailsElement.querySelectorAll('.js-details').forEach((details) => {
      details.classList.remove('menu-opening')
    })
    document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`)
  }

  onSummaryClick(event) {
    event.preventDefault()
    const summaryElement = event.currentTarget
    const detailsElement = summaryElement.parentElement
    const isOpen = this.type
      ? detailsElement.hasAttribute('open')
      : detailsElement.classList.contains('menu-opening')

    if (detailsElement === this.mainDetailsToggle) {
      this.openMenuDrawer(summaryElement)
    } else {
      if (isOpen) {
        this.type
          ? detailsElement.removeAttribute('open')
          : detailsElement.classList.remove('menu-opening')
      } else {
        if (this.type) {
          if (detailsElement.classList.contains('js-filter')) {
            this.mainDetailsToggle
              .querySelectorAll('.js-filter')
              .forEach((details) => {
                details.removeAttribute('open')
              })
          }
          detailsElement.setAttribute('open', '')
        } else {
          if (detailsElement.classList.contains('js-menu-drawer__parent')) {
            this.mainDetailsToggle
              .querySelectorAll('.js-menu-drawer__parent')
              .forEach((details) => {
                details.classList.remove('menu-opening')
              })
              document.querySelector('.menu-drawer__navigation-container').classList.add('no-scroll')
          }
          detailsElement.classList.add('menu-opening')
        }
      }
    }
  }

  openMenuDrawer(summaryElement) {
    if (this.type) {
      this.mainDetailsToggle.setAttribute('open', '')
      document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`)
    } else {
      this.mainDetailsToggle.classList.add('menu-opening')
      document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`)
    }
    summaryElement.setAttribute('aria-expanded', true)
  }

  closeMenuDrawer(event) {
    if (event !== undefined) {
      if (this.type) {
        this.mainDetailsToggle.removeAttribute('open')
        this.mainDetailsToggle
          .querySelectorAll('details')
          .forEach((details) => {
            details.removeAttribute('open')
          })
        this.mainDetailsToggle
          .querySelector('summary')
          .setAttribute('aria-expanded', false)
      } else {
        this.mainDetailsToggle.classList.remove('menu-opening')
        this.mainDetailsToggle
          .querySelectorAll('.js-details')
          .forEach((details) => {
            details.classList.remove('menu-opening')
          })
        this.mainDetailsToggle
          .querySelector('.summary')
          .setAttribute('aria-expanded', false)
      }

      document.body.classList.remove(
        `overflow-hidden-${this.dataset.breakpoint}`
      )
    }
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest(
      this.type ? 'details' : '.js-details'
    )
    this.closeSubmenu(detailsElement)
    document.querySelector('.menu-drawer__navigation-container').classList.remove('no-scroll')
  }

  closeSubmenu(detailsElement) {
    if (detailsElement) {
      if (this.type) {
        this.mainDetailsToggle.removeAttribute('open')
        this.mainDetailsToggle
          .querySelectorAll('details')
          .forEach((details) => {
            details.removeAttribute('open')
          })
        this.mainDetailsToggle
          .querySelector('summary')
          .setAttribute('aria-expanded', false)

        document.body.classList.remove(
          `overflow-hidden-${this.dataset.breakpoint}`
        )
      } else {
        detailsElement.classList.remove('menu-opening')
      }
    }
  }
}

customElements.define('menu-drawer', MenuDrawer)

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super()
  }

  openMenuDrawer(summaryElement) {
    this.header =
      this.header || document.getElementById('shopify-section-header')
    this.borderOffset =
      this.borderOffset ||
      this.closest('.header-wrapper').classList.contains(
        'header-wrapper--border-bottom'
      )
        ? 1
        : 0
    document.documentElement.style.setProperty(
      '--header-bottom-position',
      `${parseInt(
        this.header.getBoundingClientRect().bottom - this.borderOffset
      )}px`
    )

    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening')
    })

    summaryElement.setAttribute('aria-expanded', true)
    trapFocus(this.mainDetailsToggle, summaryElement)
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`)
  }
}

customElements.define('header-drawer', HeaderDrawer)

class ModalDialog extends HTMLElement {
  constructor() {
    super()
    this.querySelector('[id^="ModalClose-"]').addEventListener(
      'click',
      this.hide.bind(this)
    )
    this.addEventListener('click', (event) => {
      if (event.target.nodeName === 'MODAL-DIALOG') this.hide()
    })
    this.addEventListener('keyup', () => {
      if (event.code.toUpperCase() === 'ESCAPE') this.hide()
    })
  }

  show(opener) {
    this.openedBy = opener
    document.body.classList.add('overflow-hidden')
    this.setAttribute('open', '')
    this.querySelector('.template-popup')?.loadContent()
    trapFocus(this, this.querySelector('[role="dialog"]'))
  }

  hide() {
    document.body.classList.remove('overflow-hidden')
    this.removeAttribute('open')
    removeTrapFocus(this.openedBy)
    window.pauseAllMedia()
  }
}
customElements.define('modal-dialog', ModalDialog)

class ModalOpener extends HTMLElement {
  constructor() {
    super()

    const button = this.querySelector('button')
    button?.addEventListener('click', () => {
      document.querySelector(this.getAttribute('data-modal'))?.show(button)
    })
  }
}
customElements.define('modal-opener', ModalOpener)

class DeferredMedia extends HTMLElement {
  constructor() {
    super()
    this.querySelector('[id^="Deferred-Poster-"]')?.addEventListener(
      'click',
      this.loadContent.bind(this)
    )
  }

  loadContent() {
    if (!this.getAttribute('loaded')) {
      const content = document.createElement('div')
      content.appendChild(
        this.querySelector('template').content.firstElementChild.cloneNode(true)
      )

      this.setAttribute('loaded', true)
      //window.pauseAllMedia()
      this.appendChild(
        content.querySelector('video, model-viewer, iframe')
      ).focus()

      setTimeout(() => {
        const video = this.querySelector('template').nextElementSibling
        video.muted = video.dataset.muted === 'true'
        video.play()
      })
    }
  }
}

customElements.define('deferred-media', DeferredMedia)
